var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJustice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357.05 456.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.6,
    y1: 309,
    x2: 178.51,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.5,
    y1: 431.68,
    x2: 178.51,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 297.43,
    y1: 309,
    x2: 178.51,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.5,
    y1: 26.45,
    x2: 178.51,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.98,
    y1: 118.85,
    x2: 338.58,
    y2: 124.92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.75 37.85 169.79 26.45 158.75 15.05 174.15 18.91 178.5 3.64 182.86 18.91 198.26 15.05 187.22 26.45 198.26 37.85 182.86 34 178.5 49.26 174.15 34 158.75 37.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.71 289 170.97 284.64 167.11 269.25 178.51 280.29 189.92 269.25 186.06 284.64 201.32 289 186.06 293.35 189.92 308.75 178.51 297.71 167.11 308.75 170.97 293.35 155.71 289"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.95 431.68 184.3 437.48 178.5 453.13 172.71 437.48 157.06 431.68 172.71 425.89 178.5 410.23 184.3 425.89 199.95 431.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.17 319.72 61.72 316.91 48.87 327.57 51.68 311.12 41.02 298.27 57.48 301.09 70.32 290.42 67.51 306.88 78.17 319.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.43 102.56 26.64 118.22 34.75 132.81 19.1 127.02 4.51 135.13 10.3 119.47 2.19 104.89 17.84 110.68 32.43 102.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "316 298.27 305.34 311.12 308.15 327.57 295.31 316.91 278.85 319.72 289.52 306.88 286.71 290.42 299.55 301.09 316 298.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "352.54 108.64 346.75 124.3 354.86 138.88 339.21 133.09 324.62 141.2 330.41 125.55 322.3 110.96 337.95 116.75 352.54 108.64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustice);
export default __webpack_public_path__ + "static/media/Justice.573f2d8949e71f90732ca0f7ec8c8f9a.svg";
export { ForwardRef as ReactComponent };